import Image from 'next/legacy/image'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { colors, fontSizes } from '@/styles'

import logo from './images/liv-app-logo.png'

const Wrapper = styled.div`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  background: ${colors.white};
  width: 100%;
  height: 65px;
  position: fixed;
  z-index: 9000;
  bottom: 0;
  left: 0;
  transition: transform 0.7s ease-in;
  overflow: hidden;
  opacity: 1;
  transform: translateY(0);
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.2);
`

const InnerWrapper = styled.div`
  display: flex;
  align-items: center;
  vertical-align: middle;
  justify-content: space-between;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  max-width: 940px;

  @media (max-width: 991px) {
    margin: 0 20px;
  }

  @media (max-width: 500px) {
    > a {
      display: none;
    }
  }
`

const ContentWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
`

const ApprovalText = styled.p`
  margin: 0 20px;

  @media screen and (max-width: 560px) {
    font-size: 14px;
  }

  @media (max-width: 400px) {
    margin-left: 0;
    font-size: 12px;
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  height: 42px;
  width: auto;
  flex-shrink: 0;
`

const Button = styled.a`
  height: 40px;
  width: 160px;
  background-color: ${colors.primary};
  color: ${colors.white};
  font-size: ${fontSizes.regular};
  font-weight: 400;
  letter-spacing: 0.32px;
  line-height: 40px;
  text-align: center;
  text-decoration: none;
`

const StickyBar = ({ visible = true }) => {
  const { t } = useTranslation('w1')

  return (
    <Wrapper visible={visible}>
      <InnerWrapper>
        <Link
          href="/"
          passHref
          aria-label={t('b.landing.home.label', 'liv.rent Homepage')}
          legacyBehavior
        >
          <Image src={logo} alt="liv.rent Logo" height={45} width={90} />
        </Link>
        <ContentWrapper>
          <ApprovalText>{t('w1:Available Now!')}</ApprovalText>
          <ButtonWrapper>
            <Button
              href="https://liv.rent/building/6509/w1-north-tower-apartment-building-8080-nunavut-lane-vancouver-bc"
              id="w1-view-building-furnished-footer"
            >
              {t('w1:View Floorplans')}
            </Button>
          </ButtonWrapper>
        </ContentWrapper>
      </InnerWrapper>
    </Wrapper>
  )
}

export default StickyBar
